import Switch from "../switch";
import { getValue } from "@utils/lodash";

export default function AddLocation(props: any) {
	return (
		<div
			className={`list-managemnet-wrapper__country-items d-flex align-items-center justify-content-between ${
				getValue(props, `selected`, "") == getValue(props, `id`, "")
					? "active"
					: ""
			}`}
			onClick={() => props.onChange(getValue(props, `id`, ""))}
		>
			<h6 className="list-managemnet-wrapper__country-items-title">
				{props.name}
			</h6>
			{/* <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center"> */}
			{getValue(props, `add`, false) && (
				<div onClick={props.handleAddCategory}>
				<img
					src="/images/add-btn.svg"
					width={24}
					height={24}
					className="img-fluid"
				/>
				</div>
			)}
			{/* <img
					src="/images/list-management/country/delete-icon.svg"
					className="img-fluid"
					width={24}
					height={24}
				/>
				<Switch />
			</div> */}
		</div>
	);
}
